<template #photoGalleryContainer></template>

<template #photoContainer></template>

<template #commandContainer></template>

<app-devices-editor></app-devices-editor>

<template #mapContainer></template>
